app.components.cards = {
    onReady: function () {
        if ($('.cards').length) {
            return true;
        }
    },
    addListener: function () {
        let that = this;
        let $container = $('.cards');

        $('button.load', $container).on('click', function () {
            let button = $(this);
            let component = button.data('component');
            let template = button.data('template');
            let page = parseInt(button.data('page'));
            that.getCardsEntries(component, template, page);
            return false;
        });
    },
    getCardsEntries: function (component, template, page) {
        const $container = $('.cards').eq(0);
        $container.addClass('loading');

        let options = ['template:' + template, 'page:' + page];
        let endpoint = '?component=' + component + '&options=' + options.join(';');

        const button = $('button.load', $container);
        button.data('page', page);
        button.attr('disabled', 'disabled');

        button.fadeIn(250);
        $.get(endpoint, function (data) {
            if (data) {
                if (page > 1) {
                    $('.container', $container).append(data);
                } else {
                    $('.container', $container).html(data);
                }
                button.prop("disabled", true).removeAttr("disabled");
            } else {
                button.fadeOut(250);
            }
            $container.removeClass('loading');
        });
    }
};
